import { inTestEnvironment } from '../util/environment'

up.compiler('time', { priority: 1 }, (element, data) => {
  const time = element.getAttribute('datetime')

  if (!time) {
    return
  }
  const eventDateUtc = new Date(time) // time is in UTC

  setTooltip()

  if (data.relative) {
    printRelativeTime()
    const interval = setInterval(printRelativeTime, eventDateUtc < (nowUtc() - 60000) ? 10000 : 1000)
    return () => {
      clearInterval(interval)
    }
  }

  function nowUtc() {
    const isoDateString = new Date().toISOString()
    return new Date(isoDateString)
  }

  function setTooltip() {
    const timezone = inTestEnvironment() ? 'de-DE' : undefined
    let timeString = eventDateUtc.toLocaleString(timezone)
    // remove seconds
    timeString = timeString.replace(/:(\d{1,2}):00/, ':$1')
    element.setAttribute('title', `${timeString} your time`)
  }

  function printRelativeTime() {
    const now = nowUtc()
    const past = now > eventDateUtc
    const seconds = Math.abs(now - eventDateUtc) / 1000
    let text = secondsToProse(seconds)

    if (past) {
      text = `${text} ago`
    } else {
      text = `in ${text}`
    }

    element.textContent = text
  }

  function secondsToProse(seconds) {
    if (seconds < 60) {
      return 'Less than a minute'
    }

    const minutes = seconds / 60
    if (minutes < 60) {
      return pluralize(Math.round(minutes), 'minute')
    }

    const hours = minutes / 60
    if (hours < 24) {
      return pluralize(Math.round(hours), 'hour')
    }

    const days = hours / 24
    if (days < 365) {
      return pluralize(Math.round(days), 'day')
    }

    const years = days / 365
    return pluralize(Math.round(years), 'year')
  }

  function pluralize(amount, label) {
    if (amount === 1) {
      return `1 ${label}`
    } else {
      return `${amount} ${label}s`
    }
  }
})
